export class TrailerCover {
    id: string = '';
    quote_id: string = '';
    number_of_trailers: number = null;
    trailer_insurance_cover: number = null;
}
